/**
 * Limits and feature switches.
 *
 * The server used to answer these from `/config`; with no server they are fixed
 * at build time. The limits are the ones the API enforced, so a plan built here
 * is one the original app would also have accepted.
 */

import { MAX_SEATS, MIN_SEATS } from './geometry'

export const LIMITS = {
  minSeatsPerTable: MIN_SEATS,
  maxSeatsPerTable: MAX_SEATS,
  maxTablesPerPlan: 120,
  /** Generous — the server never capped guests — but finite. */
  maxGuestsPerPlan: 5000,
  maxPlans: 50,
  /**
   * How far from the hall's centre a table may stand, and how high the stacking
   * order may climb. A backup past either is refused, so the editor keeps every
   * value it derives inside them — or its own next backup would not restore.
   */
  maxCoordinate: 1e7,
  maxZIndex: 1e9,
  maxUploadMb: 8,
  /** Guest photos are stored fitted inside this square. */
  photoMaxEdgePx: 512,
} as const

export const MAX_UPLOAD_BYTES = LIMITS.maxUploadMb * 1024 * 1024

/**
 * Switches for features ported from the server (see ROADMAP.md). While a switch
 * is off, every entry point to that feature is hidden rather than broken, so
 * any commit can be deployed.
 */
export const FEATURES = {
  /** Phase 2: the PDF renders in the browser. */
  pdfExport: true,
  /** Phase 3: reading a venue's printed chart from a photo, in a worker. */
  floorPlanImport: true,
} as const

/** Where the landing page sends ideas, complaints and hellos. Never translated. */
export const CONTACT_EMAIL = 'contact@yerbeyer.com'
